import { combineReducers } from 'redux';
import view from './viewReducer';
import creation from './creationReducer';
import edit from './editReducer';

const meetingsReducer = combineReducers({
  creation,
  edit,
  view,
});

export default meetingsReducer;
